import * as React from 'react';
import { TabNames, TabLabels } from './props';

export interface TabItem {
  name: TabNames;
}

export interface CustomProps {
  tabs: TabItem[];
  tabChangeHandler: (tabName: TabNames) => void;
  tabName: TabNames;
  pendingCount?: number;
  requestedCount?: number;
  approvedCount?: number;
  completedCount?: number;
}

const Tabs: React.FunctionComponent<CustomProps> = (props) => {
  const [activeTab, setActiveTab] = React.useState<TabNames>(props.tabName);

  const handleTabClick = (tabName: TabNames) => {
    setActiveTab(tabName);
    props.tabChangeHandler(tabName);
  };

  return (
    <ul
      className="d-flex list-unstyled tab-underline font-sm font-weight-semibold text-nowrap overflow-auto m-0"
      id="activity-tab"
      role="tablist"
    >
      {props.tabs.map((tab) => (
        <li key={tab.name} className="nav-item pr-4 pl-4" role="presentation">
          <a
            className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
              activeTab === tab.name ? 'active' : ''
            }`}
            onClick={() => handleTabClick(tab.name)}
          >
            <span className="py-1 d-inline-flex">{tab.name}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
